import React, { useState } from 'react';
import { getConfig } from '../../../../utils/config';
import { LinkParagraph } from '../../../../helpers';

const isHTML = RegExp.prototype.test.bind(/(<([^>]+)>)/i);

function Description({ content, isRewards, title, removeTopMargin }) {
    const [showFullSpecification, setShowFullSpecification] = useState(
        content?.split(' ').length <= 70
    );
    const toggleSpecification = () => {
        setShowFullSpecification((prev) => !prev);
    };

    const config = getConfig();

    return (
        <div className={`mt-4`}>
            {isRewards && <h1 className="font-bold text-base">{title}</h1>}
            {content && isHTML(content) && (
                <div
                    style={{
                        whiteSpace: 'pre-line'
                    }}
                    className={`
${
    config?.deals.dealsSection.subAdditionalTextClass
        ? config?.deals.dealsSection.subAdditionalTextClass
        : ''
} z-10 2xl:pr-10 text-sm  ${isRewards ? 'mt-4 lg:mt-2 xl:mt-2' : 'mt-0'} `}
                    dangerouslySetInnerHTML={{
                        __html: showFullSpecification
                            ? content
                            : content.split(' ').slice(0, 50).join(' ')
                    }}
                />
            )}
            {content && !isHTML(content) && (
                <div
                    style={{
                        whiteSpace: 'pre-line'
                    }}
                    className={`
${
    config?.deals.dealsSection.subAdditionalTextClass
        ? config?.deals.dealsSection.subAdditionalTextClass
        : ''
} z-10 ${removeTopMargin ? 'mt-0' : 'lg:mt-5 xl:mt-4'}  2xl:pr-10  `}
                >
                    {LinkParagraph(
                        showFullSpecification
                            ? content
                            : content.split(' ').slice(0, 50).join(' ')
                    )}
                </div>
            )}
            {content?.split(' ').length > 70 && (
                <button
                    onClick={toggleSpecification}
                    className="text-primary text-base font-bold block"
                >
                    {showFullSpecification ? 'Read less' : 'Read more'}
                </button>
            )}
        </div>
    );
}

export default Description;
